"use client";
import Image from "next/image";
import React from "react";

export interface iProps {
  appName: string;
  imagePath: string;
  classes: string;
  styles?: {};
  index?: number;
}

const Thumbnail = (props: iProps) => {
  const {
    imagePath,
    appName,
    classes,
    index,

    styles = {
      width: "100%",
      maxHeight: "50px",
      maxWidth: "50px",
      height: "auto",
    },
  } = props;

  // Ensure `imagePath` is provided, return null otherwise
  if (!imagePath) {
    return null;
  }
  return (
    <Image
      src={imagePath} // Use the `imagePath` prop for the source
      alt={appName} // Alt text for accessibility
      width={50} // Fixed width for the thumbnail
      height={50} // Fixed height for the thumbnail
      className={classes} // Apply classes for additional styling
      priority={false} // Enable lazy loading by default
      key={imagePath} // Use `imagePath` as the key
      loading="lazy" // Ensure lazy loading for non-priority images
      style={styles}
    />
  );
};

export default Thumbnail;
